import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const PROJECT_WORKFLOW_ID_KEY = 'actuator:lastProjectId';
const PROJECT_WORKFLOW_CACHE_KEY = 'actuator:projectWorkflowTarget';
const PROJECT_WORKFLOW_CACHE_TTL = 45 * 1000;
let projectWorkflowRequest: Promise<string> | null = null;

@Component({
    standalone: false,
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public fallbackProjectId: string = '';
    public workflowTabs: any[] = [
        { key: 'design', label: '기본 설계', order: '01' },
        { key: 'documents', label: '문서 분석', order: '02' },
        { key: 'simulation', label: '시뮬레이션', order: '03' },
        { key: 'digital_twin', label: '디지털 트윈', order: '04' },
        { key: 'review', label: '결과 검토', order: '05' },
        { key: 'reports', label: '리포트', order: '06' }
    ];
    public digitalTwinTabs: any[] = [
        { path: '/digital-twin', label: '운영 모니터링', order: '01' },
        { path: '/digital-twin/kinematics', label: '3D 기구학', order: '02' },
        { path: '/digital-twin/mcu', label: 'MCU 검증', order: '03' },
        { path: '/digital-twin/pid', label: 'PID 분석', order: '04' }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.fallbackProjectId = this.cachedProjectId(true);
        await this.loadProjectWorkflowTarget();
        await this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        if (link === '/projects/new') {
            return location.pathname === '/projects/new';
        }
        if (link === '/projects') {
            return location.pathname === '/projects';
        }
        return location.pathname.indexOf(link) === 0
    }

    private isWorkflowTab(tab: string) {
        return this.workflowTabs.some((item: any) => item.key === tab || (tab === 'verification' && item.key === 'review'));
    }

    private queryProjectId(): string {
        try {
            return new URLSearchParams(location.search).get('project_id') || '';
        } catch (e) {
            return '';
        }
    }

    private isProjectScopedDigitalTwin(): boolean {
        return location.pathname.indexOf('/digital-twin') === 0 && !!this.queryProjectId();
    }

    private pathProjectId(): string {
        const match = location.pathname.match(/^\/projects\/([^\/]+)/);
        if (!match || match[1] === 'new') return '';
        if (this.isWorkflowTab(match[1])) return '';
        return match[1];
    }

    public currentProjectId(): string {
        return this.pathProjectId() || (this.isProjectScopedDigitalTwin() ? this.queryProjectId() : '');
    }

    private storedProjectId(): string {
        try {
            return localStorage.getItem(PROJECT_WORKFLOW_ID_KEY) || '';
        } catch (e) {
            return '';
        }
    }

    private cacheOwner(): string {
        return String(this.service.auth.session?.id || this.service.auth.session?.email || '');
    }

    private cachedProjectId(allowStale: boolean = false): string {
        try {
            const raw = sessionStorage.getItem(PROJECT_WORKFLOW_CACHE_KEY);
            if (!raw) return '';
            const cached = JSON.parse(raw);
            const id = cached && cached.id ? String(cached.id) : '';
            const cachedAt = Number(cached && cached.cachedAt ? cached.cachedAt : 0);
            const owner = cached && cached.owner ? String(cached.owner) : '';
            if (!id || !owner || owner !== this.cacheOwner()) return '';
            if (!allowStale && Date.now() - cachedAt > PROJECT_WORKFLOW_CACHE_TTL) return '';
            return id;
        } catch (e) {
            return '';
        }
    }

    private cacheProjectId(id: string) {
        const owner = this.cacheOwner();
        if (!id || !owner) return;
        try {
            sessionStorage.setItem(PROJECT_WORKFLOW_CACHE_KEY, JSON.stringify({ id, owner, cachedAt: Date.now() }));
        } catch (e) {}
    }

    private rememberProjectId(id: string) {
        if (!id || id === 'new' || this.isWorkflowTab(id)) return;
        this.fallbackProjectId = id;
        try {
            localStorage.setItem(PROJECT_WORKFLOW_ID_KEY, id);
        } catch (e) {}
    }

    private workflowProjectId(): string {
        const id = this.currentProjectId() || this.fallbackProjectId || this.storedProjectId();
        return id || '';
    }

    private requestProjectWorkflowTarget(): Promise<string> {
        if (projectWorkflowRequest) return projectWorkflowRequest;

        const request = (async () => {
            const res = await fetch('/wiz/api/page.projects/list', {
                method: 'POST',
                credentials: 'same-origin'
            });
            const data = await res.json();
            if (!data || data.code !== 200) return '';

            const payload = (data.data && data.data.data) || data.data || {};
            const items = payload.items || [];
            if (!items.length) return '';

            const stored = this.storedProjectId();
            const target = items.find((item: any) => item.id === stored) || items[0];
            return target && target.id ? String(target.id) : '';
        })();

        projectWorkflowRequest = request;
        request.then(
            () => { projectWorkflowRequest = null; },
            () => { projectWorkflowRequest = null; }
        );
        return request;
    }

    private async loadProjectWorkflowTarget() {
        const currentId = this.currentProjectId();
        if (currentId) {
            this.rememberProjectId(currentId);
            this.cacheProjectId(currentId);
            return;
        }

        const cachedId = this.cachedProjectId();
        if (cachedId) {
            this.rememberProjectId(cachedId);
            return;
        }

        try {
            const targetId = await this.requestProjectWorkflowTarget();
            if (!targetId) return;
            this.rememberProjectId(targetId);
            this.cacheProjectId(targetId);
        } catch (e) {
            const fallbackId = this.cachedProjectId(true);
            if (fallbackId) this.rememberProjectId(fallbackId);
        }
    }

    public showProjectWorkflow(): boolean {
        return location.pathname === '/projects'
            || (location.pathname.indexOf('/projects/') === 0 && location.pathname !== '/projects/new')
            || this.isProjectScopedDigitalTwin();
    }

    public showProjectReturn(): boolean {
        return this.isProjectScopedDigitalTwin();
    }

    public currentProjectTab(): string {
        if (this.isProjectScopedDigitalTwin()) return 'digital_twin';
        const match = location.pathname.match(/^\/projects\/[^\/]+\/([^\/]+)/);
        const params = new URLSearchParams(location.search);
        const rawTab = match ? match[1] : (params.get('stage') || params.get('tab') || 'design');
        const tab = rawTab === 'verification' ? 'review' : rawTab;
        return this.workflowTabs.some((item: any) => item.key === tab) ? tab : 'design';
    }

    public projectWorkflowClass(tab: string) {
        if (this.currentProjectTab() === tab) {
            return "flex w-full items-center justify-between rounded-lg border border-cyan-300/30 bg-cyan-300/15 px-2.5 py-2 text-left text-[12px] font-semibold text-cyan-50";
        }
        return "flex w-full items-center justify-between rounded-lg px-2.5 py-2 text-left text-[12px] font-medium text-slate-400 transition-colors hover:bg-white/5 hover:text-white";
    }

    public projectWorkflowUrl(tab: string) {
        const id = this.workflowProjectId();
        return id ? `/projects/${id}/${tab}` : `/projects?stage=${tab}`;
    }

    public isDigitalTwinActive(path: string) {
        if (path === '/digital-twin') return location.pathname === '/digital-twin';
        return location.pathname === path;
    }

    public showDigitalTwinMenu(): boolean {
        return location.pathname.indexOf('/digital-twin') === 0;
    }

    public digitalTwinClass(path: string) {
        if (this.isDigitalTwinActive(path)) {
            return "flex w-full items-center justify-between rounded-lg border border-cyan-300/30 bg-cyan-300/15 px-2.5 py-2 text-left text-[12px] font-semibold text-cyan-50";
        }
        return "flex w-full items-center justify-between rounded-lg px-2.5 py-2 text-left text-[12px] font-medium text-slate-400 transition-colors hover:bg-white/5 hover:text-white";
    }

    public digitalTwinUrl(path: string) {
        const id = this.workflowProjectId();
        return id ? `${path}?project_id=${encodeURIComponent(id)}` : path;
    }

    public isAdmin() {
        return this.service.auth.session?.role === 'admin';
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex w-full gap-x-2.5 items-center rounded-xl border border-cyan-300/40 bg-cyan-300/15 px-3 py-2.5 text-left text-[13px] font-semibold text-white shadow-sm shadow-cyan-950/40";
        }
        return "group flex w-full gap-x-2.5 items-center rounded-xl px-3 py-2.5 text-left text-[13px] font-medium text-slate-300 transition-colors hover:bg-white/8 hover:text-white";
    }

    public async navigate(path: string) {
        const match = path.match(/^\/projects\/([^\/\?]+)/);
        if (match) this.rememberProjectId(match[1]);
        this.service.href(path);
        this.service.status.toggle('navbar', true);
        await this.service.render();
    }

    public async logout() {
        this.service.auth.forgetSession();
        try {
            localStorage.removeItem(PROJECT_WORKFLOW_ID_KEY);
            sessionStorage.removeItem(PROJECT_WORKFLOW_CACHE_KEY);
        } catch (e) {}
        try {
            await fetch('/wiz/api/page.access/logout', { method: 'POST' });
        } catch (e) {}
        location.href = "/access";
    }
}

export default ComponentNavSidebarComponent;